export default {
  title: "",
}



// WEBPACK FOOTER //
// ./src/locales/no/page/home.js